import styled from 'styled-components'

const Header = styled.h2`
  color: #af1214;
  text-align: center;
  margin-top: 36px;
  padding-bottom: 18px;
  font-size: 36px;
  letter-spacing : normal;
  font-stretch : normal;
  font-style: normal;
  font-weight: normal;
`

const PageHeader = () => (
  <Header>File Uploads</Header>
)

export { Header, PageHeader }
